module.exports = __webpack_public_path__ + "img/Filter.307b63fd.png";